import { render, staticRenderFns } from "./TeamGame.vue?vue&type=template&id=4bf5e925&"
import script from "./TeamGame.vue?vue&type=script&lang=js&"
export * from "./TeamGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports